import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { refreshToken } from "../../store/actions";

const preLoginRoutes = [
  "/",
  "/login",
  "/otp",
  "/forgot-userid",
  "/forgot-password",
  "/reset-password",
  "/register",
];

export default function RefreshToken(): null {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (preLoginRoutes.find((route) => route === pathname)) return;

    refreshToken()(dispatch);
  }, [pathname, dispatch]);
  return null;
}
